import { cronToParts, DAY_NAMES, DAY_SHORT, REPEAT } from '@/features/chat/phase1/cronParts'
import { timezoneAbbrev } from './timezoneAbbrev'

const pad = (value) => String(value).padStart(2, '0')

const weeklyLabel = (weekdays = []) => {
  if (weekdays.length === 1) return `Every ${DAY_NAMES[weekdays[0]]}`
  if (!weekdays.length) return 'Weekly'
  return `Every ${weekdays.map((day) => DAY_SHORT[day]).join(', ')}`
}

/** How often, in the words the cards and sidebar rows use. Never a cron string. */
export function scheduleCadenceLabel(cron) {
  const parts = cronToParts(cron)
  switch (parts.repeat) {
    case REPEAT.HOURLY:
      return 'Every hour'
    case REPEAT.DAILY:
      return 'Everyday'
    case REPEAT.WEEKDAYS:
      return 'Every weekday'
    case REPEAT.WEEKLY:
      return weeklyLabel(parts.weekdays)
    case REPEAT.MONTHLY:
      return `Day ${parts.dayOfMonth} monthly`
    case REPEAT.CUSTOM:
      return `Every ${parts.every} ${parts.unit}`
    default:
      return 'Custom'
  }
}

/** "10:00", or empty for cadences that carry no wall-clock time (hourly, custom). */
export function scheduleTimeLabel(cron) {
  const parts = cronToParts(cron)
  const timed = [REPEAT.DAILY, REPEAT.WEEKDAYS, REPEAT.WEEKLY, REPEAT.MONTHLY]
  if (!timed.includes(parts.repeat)) return ''
  return `${pad(parts.hour)}:${pad(parts.minute)}`
}

/**
 * "10:00 IST" — the time half of a card's cadence line, and empty when the
 * cadence has no wall-clock time: a bare "IST" beside "Every 6 minutes" reads
 * like a missing value rather than a zone.
 */
export function scheduleClockLabel(cron, timezone) {
  const time = scheduleTimeLabel(cron)
  if (!time) return ''
  return [time, timezoneAbbrev(timezone)].filter(Boolean).join(' ')
}
